import { render, staticRenderFns } from "./addMaterial.vue?vue&type=template&id=640b312a&scoped=true"
import script from "./addMaterial.vue?vue&type=script&lang=js"
export * from "./addMaterial.vue?vue&type=script&lang=js"
import style0 from "./addMaterial.vue?vue&type=style&index=0&id=640b312a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b312a",
  null
  
)

export default component.exports